import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import AHFKiosk from './CompletePageVersions/AHFKiosk';
import Generic from './CompletePageVersions/Generic';
import TelehealthGeneric from './CompletePageVersions/TelehealthGeneric';
import TelehealthInitial from './CompletePageVersions/TelehealthInitial';
import TelehealthRenewal from './CompletePageVersions/TelehealthRenewal';
import { Alert, Button, Spinner } from '$HVUI';
import { useFetch } from '$Hooks';
const Complete = (props) => {
    const { companyName, isKiosk, isTelehealth } = props;
    const history = useHistory();
    // only for telehealth patients. returns initial, renewal, or generic
    const { data, error: nextLocationError, loading: nextLocationLoading } = useFetch(`/api/v2/forms/next_location/`, {}, []);
    const landingType = data === null || data === void 0 ? void 0 : data.next_landing_type;
    const isInitial = landingType === 'initial';
    const isRenewal = landingType === 'renewal';
    const isGeneric = landingType === 'generic';
    if (nextLocationError) {
        return (_jsxs(_Fragment, { children: [_jsx(Alert, { type: "error", message: "Sorry, something went wrong. Please go back and try again.", style: {
                        margin: '2rem auto',
                        textAlign: 'center',
                        maxWidth: '600px'
                    } }), _jsx(Button, { text: "Go back", onClick: () => history.push('/'), level: "primary" })] }));
    }
    if (nextLocationLoading) {
        return _jsx(Spinner, { center: true });
    }
    const Component = isKiosk ? (_jsx(AHFKiosk, {})) : isTelehealth && isInitial ? (_jsx(TelehealthInitial, {})) : isTelehealth && isRenewal ? (_jsx(TelehealthRenewal, {})) : isTelehealth && isGeneric ? (_jsx(TelehealthGeneric, {})) : (_jsx(Generic, { companyName: companyName }));
    return Component;
};
export default Complete;
